const joinClassNames = (...parts) => parts.filter(Boolean).join(' ')

export default function LoadingState({ title = 'Loading', message = '', action = null, className = '' }) {
  return (
    <article className={joinClassNames('gg-loading', className)}>
      <div className="gg-loading__spinner" aria-hidden="true" />
      <h3 className="gg-loading__title">{title}</h3>
      <p className="gg-loading__message">{message || 'Please wait...'}</p>
      {action ? <div className="gg-loading__action">{action}</div> : null}
    </article>
  )
}
